/* eslint-disable no-nested-ternary */
import { Buffer } from 'buffer';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { META_COLLECT_API } from '../../api';
import { useSigninContext } from '../../context/AuthProviderPages/Signin';
import { CollectRegister } from '../../types/CollectRegister';
import { Statistic } from '../../types/Statistic';
import { StopedCollectRegister } from '../../types/StopedCollectRegister';
import { formatDate } from '../../utils/date/formatDate';
import { formatReceiveSeconds } from '../../utils/formatReceiveSeconds';
import { getGoogleMapsUrl } from '../../utils/getGoogleMapsUrl';
import { returnRegisterType } from '../../utils/returnRegisterType';
import { toBase64 } from '../../utils/toBase64';
import { DontExistsItem } from '../DontExistsItem';
import { DontExistsItemFlex } from '../DontExistsItem/styles';
import { LoadingData } from '../LoadingData';
import { CollectItemPhotosModal } from '../Modal/CollectItemPhotosModal';
import { ModalInfoTemplete } from '../Modal/ModalInfoTemplete';
import { renderIcon } from './renderIcon';
import {
  CardActionButton,
  CardActionsRow,
  CardOdometerContaner,
  ContainerStatisticsTimeLine,
  ImagePreview,
  MouthCollectionItem,
  MouthContainer,
  MouthDischargeItem,
  MouthHeader,
  MouthTemperature,
  TankPinCheckinIcon,
  TimeLineCard,
  TimeLineCurrentTime,
  PhotosCountLabel,
  TimeLineSpace,
  TimeLineSpaceContainer,
} from './styles';

interface IStatisticsTimeLine {
  statistics: Statistic[];
  loading: boolean;
}

interface ICardSpace {
  index: number;
  statistics: Statistic[];
}

const CardSpace = ({ index, statistics }: ICardSpace) => {
  const isRender = index < statistics.length - 1;
  return isRender ? (
    <TimeLineSpaceContainer>
      <TimeLineSpace />
      <TimeLineCurrentTime>
        <span>{statistics[index].DFDIFERENCAEMSEGUNDOS}</span>
      </TimeLineCurrentTime>
    </TimeLineSpaceContainer>
  ) : (
    <></>
  );
};

const CardImage = ({ DFTIPOREGISTRO, DFIDREGISTRO }: CollectRegister) => {
  const [image, setImage] = useState<string>();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const { path } = useSigninContext();

  useEffect(() => {
    META_COLLECT_API.get(`/itemregistro?DFIDREGISTRO=${DFIDREGISTRO}`, {
      headers: { path },
    })
      .then(response => {
        const [item] = response.data.itens;
        if (item) setImage(Buffer.from(item.DFREGISTROIMAGEM.data).toString());
      })
      .catch(() => toast.error('Erro ao carregar a foto do registro.'));
  }, []);

  if (!image) return null;

  const imageAlt =
    DFTIPOREGISTRO === 'K' ? 'Foto do check-in' : 'Imagem de Odômetro';
  const imageSrc = toBase64(image);
  return (
    <>
      <CardOdometerContaner
        type="button"
        aria-label="Ampliar foto"
        onClick={() => setIsPreviewOpen(true)}
      >
        <img src={imageSrc} alt={imageAlt} />
      </CardOdometerContaner>
      <ModalInfoTemplete
        option="coleta-item"
        titleModal={imageAlt}
        closeModal={setIsPreviewOpen}
        isOpen={isPreviewOpen}
        compactHeader
        large
        closeOnEscAndBackdrop
      >
        <ImagePreview src={imageSrc} alt={imageAlt} />
      </ModalInfoTemplete>
    </>
  );
};

const PhotosCountLabelText = (count: number) =>
  count === 0
    ? 'Nenhuma imagem adicionada à coleta'
    : `${count} ${count > 1 ? 'imagens' : 'imagem'} adicionada${
        count > 1 ? 's' : ''
      } à coleta`;

const StatisticsTimeLine = ({ statistics, loading }: IStatisticsTimeLine) => {
  const [isPhotosModalOpen, setIsPhotosModalOpen] = useState(false);
  const [selectedItemColeta, setSelectedItemColeta] = useState<
    string | undefined
  >(undefined);

  const handleViewPhotos = (DFIDITEMCOLETA: string) => {
    setSelectedItemColeta(DFIDITEMCOLETA);
    setIsPhotosModalOpen(true);
  };

  const renderTimeLine = () => {
    return statistics.map((item, index) => {
      const { DFTIPO } = item;
      let current;
      if (DFTIPO === 'R') {
        current = item as CollectRegister;
        const {
          DFTIPOREGISTRO,
          DFTIPOITEMCOLETA,
          DFOBSERVACAO,
          DFDESCTANQUE,
          DFQTDCOLETADA,
          DFTEMPERATURA,
          DFDATAREGISTRO,
          DFHORAREGISTRO,
          DFHORACOLETA,
          DFIDITEMCOLETA,
          DFTOTALFOTOS,
          DFLOCALIZACAO,
        } = current;
        const isDescarga = DFTIPOREGISTRO === 'D';
        const mouthsFiltered =
          current.BOCASARMAZENADAS?.filter(boca => Number(boca.DFVOLUME) > 0) ||
          [];

        return (
          <div key={current.DFIDREGISTRO}>
            <TimeLineCard
              DFTIPOREGISTRO={DFTIPOREGISTRO!}
              DFTIPOITEMCOLETA={DFTIPOITEMCOLETA}
            >
              <div className="icon">
                {DFTIPOREGISTRO === 'K' ? (
                  <TankPinCheckinIcon />
                ) : (
                  <img src={renderIcon(DFTIPOREGISTRO!)} />
                )}
              </div>
              <div className="card-column">
                <span>
                  {returnRegisterType(DFTIPOREGISTRO, DFTIPOITEMCOLETA)}
                </span>
                <p>
                  <b>Observação: </b>
                  {DFOBSERVACAO || 'Não informada'}
                </p>
                {DFDESCTANQUE && (
                  <p>
                    <b>Tanque:</b> {DFDESCTANQUE}
                  </p>
                )}
                {DFTIPOREGISTRO !== 'O' && DFTIPOREGISTRO !== 'K' && (
                  <>
                    {DFQTDCOLETADA && (
                      <p>
                        <b>Volume:</b> {DFQTDCOLETADA}L
                      </p>
                    )}
                    {DFTEMPERATURA && (
                      <p>
                        <b>Temperatura:</b> {DFTEMPERATURA}°
                      </p>
                    )}

                    {mouthsFiltered.length > 0 && (
                      <MouthContainer isDescarga={isDescarga}>
                        <MouthHeader>
                          <b>
                            {isDescarga
                              ? 'Dados de Armazenamento:'
                              : 'Armazenamento por Boca:'}
                          </b>
                        </MouthHeader>
                        {mouthsFiltered.map((boca, idx) =>
                          isDescarga ? (
                            <MouthDischargeItem
                              key={`${boca.DFBOCA}-${
                                boca.DFIDSILO ?? ''
                              }-${idx}`}
                            >
                              <p>
                                <b>Boca:</b> {boca.DFBOCA} | <b>Volume:</b>{' '}
                                {boca.DFVOLUME}L
                              </p>
                              {boca.DFDESCRICAOSILO && (
                                <>
                                  <p>
                                    <b>Silo:</b>
                                    {boca.DFDESCRICAOSILO}
                                  </p>
                                  {boca.DFTEMPERATURA && (
                                    <MouthTemperature>
                                      Temp: {boca.DFTEMPERATURA}°
                                    </MouthTemperature>
                                  )}
                                </>
                              )}
                            </MouthDischargeItem>
                          ) : (
                            <MouthCollectionItem
                              key={`${boca.DFBOCA}-${
                                boca.DFIDSILO ?? ''
                              }-${idx}`}
                            >
                              • Boca {boca.DFBOCA}: {boca.DFVOLUME}L
                            </MouthCollectionItem>
                          ),
                        )}
                      </MouthContainer>
                    )}
                  </>
                )}
                {DFDATAREGISTRO && (
                  <p>
                    <b>Data e Hora:</b> {formatDate(DFDATAREGISTRO)}
                    &nbsp; às{' '}
                    {(DFTIPOREGISTRO === 'K'
                      ? DFHORAREGISTRO
                      : DFHORACOLETA || DFHORAREGISTRO) || '-'}
                  </p>
                )}
                {DFTIPOREGISTRO === 'K' &&
                  DFLOCALIZACAO &&
                  DFLOCALIZACAO.coordinates.length >= 2 && (
                    <CardActionsRow>
                      <CardActionButton
                        as="a"
                        href={getGoogleMapsUrl(DFLOCALIZACAO.coordinates)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Localização
                      </CardActionButton>
                    </CardActionsRow>
                  )}
                {DFTIPOREGISTRO === 'C' &&
                  DFTIPOITEMCOLETA === 'C' &&
                  DFIDITEMCOLETA && (
                    <CardActionsRow>
                      <CardActionButton
                        type="button"
                        onClick={() => handleViewPhotos(DFIDITEMCOLETA)}
                      >
                        Fotos
                      </CardActionButton>
                      {DFTOTALFOTOS !== undefined && (
                        <PhotosCountLabel>
                          {PhotosCountLabelText(DFTOTALFOTOS)}
                        </PhotosCountLabel>
                      )}
                    </CardActionsRow>
                  )}
              </div>
            </TimeLineCard>
            {['1', '2', 'K'].includes(DFTIPOREGISTRO) && (
              <CardImage {...current} />
            )}
            <CardSpace {...{ index, statistics }} />
          </div>
        );
      }
      current = item as StopedCollectRegister;
      const {
        DFFIMDATAPARADA,
        DFFIMHORAPARADA,
        DFINICIODATAPARADA,
        DFINICIOHORAPARADA,
        DFSEGUNDOSPARADO,
      } = current;
      return (
        <div key={`P-${DFINICIODATAPARADA}-${DFINICIOHORAPARADA}`}>
          <TimeLineCard DFTIPOREGISTRO={'P'}>
            <div className="icon">
              <img src={renderIcon('P')} />
            </div>
            <div className="card-column">
              <span>{returnRegisterType('P', undefined)}</span>
              <p>
                <b>Observação: </b> Carreteiro ficou parado entre {`\n`}
                <b>
                  {formatDate(DFINICIODATAPARADA)} às{' '}
                  {DFINICIOHORAPARADA || '-'}
                </b>
                <a> e </a>
                <b>
                  {formatDate(DFFIMDATAPARADA)} às {DFFIMHORAPARADA || '-'}
                </b>
                <a> durante {formatReceiveSeconds(DFSEGUNDOSPARADO)}</a>
              </p>
            </div>
          </TimeLineCard>
          <CardSpace {...{ index, statistics }} />
        </div>
      );
    });
  };

  return (
    <ContainerStatisticsTimeLine
      style={{
        alignItems: `${loading ? 'center' : 'normal'}`,
        justifyContent: `${loading ? 'center' : 'normal'}`,
      }}
    >
      {loading === true ? (
        <LoadingData title="Carregando dados!" />
      ) : statistics.length > 0 && loading === false ? (
        <>{renderTimeLine()}</>
      ) : (
        loading === false &&
        statistics.length === 0 && (
          <DontExistsItemFlex>
            <DontExistsItem title="Nenhum item foi encontrado!" />
          </DontExistsItemFlex>
        )
      )}
      <CollectItemPhotosModal
        isOpen={isPhotosModalOpen}
        onRequestClose={() => setIsPhotosModalOpen(false)}
        DFIDITEMCOLETA={selectedItemColeta}
      />
    </ContainerStatisticsTimeLine>
  );
};

export { StatisticsTimeLine };
